// Opens/closes the slide-in mobile navigation panel by toggling `.open`
// on `#mobile-nav`. Closes on link click and on backdrop click.
export default function initMobileNav() {
  const burger = document.getElementById("burger")
  const mobileNav = document.getElementById("mobile-nav")
  const closeNav = document.getElementById("close-nav")
  if (!burger || !mobileNav) return

  const open = () => mobileNav.classList.add("open")
  const close = () => mobileNav.classList.remove("open")

  burger.addEventListener("click", open)
  if (closeNav) closeNav.addEventListener("click", close)

  mobileNav.querySelectorAll(".nav-link").forEach((link) => {
    link.addEventListener("click", close)
  })

  // Close on backdrop click (anywhere outside the panel and burger).
  document.addEventListener("click", (e) => {
    if (
      mobileNav.classList.contains("open") &&
      !mobileNav.contains(e.target) &&
      !burger.contains(e.target)
    ) {
      close()
    }
  })
}
